import { render } from "./PrivacyPage.vue?vue&type=template&id=e179c578&scoped=true"
import script from "./PrivacyPage.vue?vue&type=script&lang=js"
export * from "./PrivacyPage.vue?vue&type=script&lang=js"

import "./PrivacyPage.vue?vue&type=style&index=0&id=e179c578&scoped=true&lang=css"

import exportComponent from "D:\\dev\\ai inventory\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e179c578"]])

export default __exports__